import FirebaseService from "../FirebaseService";

export const NotificationFirebaseService = () => {
  const NOTIFICATION_COLLECTION_NAME = 'notifications'

  return {
    listenAdminNotification(callback) {
      return FirebaseService.firestore()
        .collection(NOTIFICATION_COLLECTION_NAME)
        .doc('admin')
        .onSnapshot(snapshot => callback(snapshot.data()))
    }
  }
}
